module.exports = __webpack_public_path__ + "static/img/tj.4cdaa26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tj.png
// module id = KScg
// module chunks = 0